import URI from "urijs";
import isDefined from "../Core/isDefined";
import loadWithXhr from "../Core/loadWithXhr";
import loadXML from "../Core/loadXML";
export default function XmlRequestMixin(Base) {
  class XmlRequestMixin extends Base {
    getXml(url, parameters) {
      if (isDefined(parameters)) {
        url = new URI(url).query(parameters).toString();
      }
      return loadXML(url);
    }
    postXml(url, data) {
      return loadWithXhr({
        url: url,
        method: "POST",
        data,
        overrideMimeType: "text/xml",
        responseType: "document"
      });
    }
  }
  return XmlRequestMixin;
}